import { ColorCodes } from "../../../../types/common";

const colorCodes: ColorCodes = {
  white: "#555555",
  red: "#FF5233",
  orange: "#ffb554",
  redShadow: "#f95460",
  green: "#7ED34E",
  greenShadow: "#7ED34E",
};

export default colorCodes;

